module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em_primary_hover-523afabf6a23f7ae5c4e34117b9e97d8.svg";